import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
import radarChart from '@/components/bigDataChart/radarChart';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'waterRadarChart',
  mixins: [GetSiteIdMixin],
  props: {
    width: {
      type: String,
      default: '80vw'
    },
    height: {
      type: String,
      default: '600px'
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    reportType: {
      type: String,
      default: ''
    },
    initNum: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      selectedData: {}
    };
  },
  components: {
    radarChart: radarChart
  },
  mounted: function mounted() {
    var _this = this;

    this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/chart';
    window.addEventListener('setItem', function (e) {
      if (e.key == 'siteType') {
        _this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/chart';
      }
    });
  },
  methods: {
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(reportType) {
      var _this2 = this;

      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!this.$refs.chart4) return;
      var that = this;
      var params = {
        stime: this.startTime,
        etime: this.endTime,
        scopeId: window.sessionStorage.getItem('siteId') || '',
        type: '4',
        dataType: reportType,
        column: 'data_time',
        order: 'asc'
      };
      var options = [];
      getAction(this.url, params).then(function (res) {
        if (res.success) {
          var data = {
            seriesData: [],
            indicatorData: [],
            legendData: [],
            codeObj: {}
          };
          var newData = res.result.records[0];
          res.result.query.factors.forEach(function (element) {
            options.push({
              label: element.alias || element.title,
              value: element.code,
              categoryName: element.categoryName
            });
            data.codeObj[element.code] = element;
            data.indicatorData.push({
              name: element.alias || element.title,
              unit: element.unitName || '',
              max: 150
            });
          });
          res.result.records.forEach(function (item) {
            var factors = [];
            data.legendData.push(item.dataTime);

            for (var key in item.factor) {
              factors.push(item.factor[key].value);
            }

            data.seriesData.push({
              type: 'radar',
              symbol: 'none',
              lineStyle: {
                width: 1
              },
              emphasis: {
                areaStyle: {
                  color: 'rgba(0,250,0,0.3)'
                }
              },
              data: [{
                value: factors,
                name: item.dataTime
              }]
            });
          });
          that.selectedData = data;

          if (state) {
            _this2.$nextTick(function () {
              that.$parent.$parent.$refs.colControl.firstState = true;
            });
          }

          console.log('selectedData', that.selectedData);
          that.$emit('factorOption', options); // that.$refs.chart4.initRadarChart(data)
        }
      });
    },
    changeChartInit: function changeChartInit(data) {
      console.log('data', data);
      this.$refs.chart4.initRadarChart(data);
    }
  },
  watch: {
    currentSiteId: function currentSiteId() {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.querySewageQuotaList(this.reportType);
      }
    },
    initNum: function initNum() {
      this.querySewageQuotaList(this.reportType, false);
    }
  }
};